<!--
 * @Author: shiao
 * @Date: 2020-12-28 17:18:09
 * @LastEditTime: 2021-01-28 14:11:31
 * @Description: 
 * @LastEditors: shiao
 * @FilePath: \o2o-appd:\gongsi\h5-hotel\h5\src\pages\hotel\detail\components\skeleton-hotelinfo.vue
-->
<template>
  <div class="info-skeleton">
    <div class="one"><skeleton width="24.0rem" height="2.2rem" /></div>
    <div class="two">
      <skeleton width="5.0rem" height="2.2rem" />
      <skeleton width="5.0rem" height="2.2rem" />
      <skeleton width="5.0rem" height="2.2rem" />
      <skeleton width="5.0rem" height="2.2rem" />
      <skeleton width="5.0rem" height="2.2rem" />
    </div>
    <div class="three">
      <skeleton width="18.5rem" height="2.2rem" />
      <skeleton width="4.0rem" height="2.2rem" />
    </div>
    <div class="four">
      <skeleton width="25.7rem" height="2.2rem" />
    </div>
    <div class="four">
      <skeleton width="20.9rem" height="2.2rem" />
    </div>
    <div class="four">
      <skeleton width="16.0rem" height="2.2rem" />
    </div>
  </div>
</template>

<script>
import skeleton from "../../components/skeleton.vue";
export default {
  components: {
    skeleton,
  },
};
</script>
<style >
html {
  font-size: calc(var(--sizeScale2) * 10px);
}
</style>
<style scoped lang='less'>
.one {
  margin-bottom: 1.0rem;
}
.two,
.three,
.four {
  margin-bottom: 0.5rem;
}
.s-box {
  display: inline-block;
}
.info-skeleton {
  padding: 2.0rem 1.5rem 1.5rem;
  .two {
    .s-box {
      margin-right: 0.5rem;
    }
  }
  .three {
    .s-box:first-child {
      margin-right: 9.0rem;
    }
  }
}
</style>